import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-sales-readings',
  templateUrl: './sales-readings.component.html',
  styleUrls: ['./sales-readings.component.css']
})
export class AdminSalesReadingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

} 